import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "profile-instructions" }
const _hoisted_2 = { class: "instructions-header" }
const _hoisted_3 = { class: "instructions-title" }
const _hoisted_4 = { class: "instructions-scroll" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "instructions-footer" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppStoreIosProfileInstructionsPopup',
  emits: ["download"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const { t, locale } = useI18n();
const visible = ref(false);

const stepImages = computed(() => {
  const suffix = locale.value === 'pt' ? '' : '_en';
  return [1, 2, 3, 4, 5, 6, 7].map((n) => `/static/home/step${n}${suffix}.jpg`);
});

const open = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

const onDownload = () => {
  close();
  emit('download');
};

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: visible.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    round: "",
    class: "profile-popup-overlay",
    onClickOverlay: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            class: "header-side",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('download.pwaDownloadInstructions')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close-btn",
            "aria-label": "Close",
            onClick: close
          }, "✕")
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepImages.value, (src, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              src: src,
              alt: `Step ${index + 1}`,
              class: "step-image"
            }, null, 8, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_button, {
            class: "download-btn",
            block: "",
            onClick: onDownload
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('system.download')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})